import qs from "qs";

let values = {};

if (
  process.env.REACT_APP_NODE_ENV !== "production" &&
  global.window &&
  global.window.location
) {
  const query = qs.parse(global.window.location.search, {
    ignoreQueryPrefix: true,
  });
  if (query && query.debug) {
    values = query;
  }
}

const defaultValues = {
  API_URL: process.env.REACT_APP_API_URL,
  REMOTE_CONFIG_URL: process.env.REACT_APP_REMOTE_CONFIG_URL,
  CONSULTA_NOTA_FISCAL_URL: process.env.REACT_APP_CONSULTA_NOTA_FISCAL_URL,
  API_AUTH_URL: process.env.REACT_APP_API_AUTH_URL,
  LOGOUT_URL: process.env.REACT_APP_LOGOUT_URL,
  API_URL_OP: process.env.REACT_APP_API_URL_OP,
  USER_KEY: process.env.REACT_APP_USER_KEY,
  APP_VERSION: process.env.REACT_APP_VERSION,
  GRID_QTD: process.env.REACT_APP_GRID_QTD,
  ROWS_PER_PAGE: Number(process.env.REACT_APP_ROWS_PER_PAGE),
  EDIT_IMMEDIATELY: process.env.REACT_APP_EDIT_IMMEDIATELY === "true",
  SHOW_TUTORIAL: process.env.REACT_APP_SHOW_TUTORIAL === "true",
  ENABLE_LOGIN: process.env.REACT_APP_ENABLE_LOGIN === "true",
  NOW_READ_ONLY: process.env.REACT_APP_NOW_READ_ONLY === "true",
  DEBUG_ENABLED: process.env.REACT_APP_DEBUG_ENABLED === "true",
  RETRY_DELAY_MINUTES: Number(process.env.REACT_APP_RETRY_DELAY_MINUTES),
  DEBUG_LOGIN: process.env.REACT_APP_DEBUG_LOGIN,
  NOTIFICATIONS_SERVICE: process.env.REACT_APP_NOTIFICATIONS_SERVICE,
  NOTIFICATIONS_SERVICE_ENABLED:
    process.env.REACT_APP_NOTIFICATIONS_SERVICE_ENABLED === "true",
  POOLING_LIST_DELAY: process.env.REACT_APP_POOLING_LIST_DELAY,
  POOLING_DETAILS_DELAY: process.env.REACT_APP_POOLING_DETAILS_DELAY,
  POOLING_VERSION_CHECK_DELAY:
    process.env.REACT_APP_POOLING_VERSION_CHECK_DELAY,
  CATALOGO_URL: process.env.REACT_APP_CATALOGO_URL,
  AME_INTEGRADOR_URL: process.env.REACT_APP_AME_INTEGRADOR_URL,
  AME_INTEGRADOR_TOKEN: process.env.REACT_APP_AME_INTEGRADOR_TOKEN,
  BOTMAKER_BASE_URL: process.env.REACT_APP_BOTMAKER_BASE_URL,
  NOTA_FISCAL_URL: process.env.REACT_APP_NOTA_FISCAL_URL,
  NOTA_FISCAL_URL_RECEITA_FEDERAL: process.env.REACT_APP_NOTA_FISCAL_URL_RECEITA_FEDERAL,
  MAESTRO_LOGS_URL: process.env.REACT_APP_MAESTRO_LOGS_URL,
  DEBUG_PASSWORD: process.env.REACT_APP_DEBUG_PASSWORD,
  DEBUG_USER_NAME: process.env.REACT_APP_DEBUG_USER_NAME,
  DEBUG_USER_EMAIL: process.env.REACT_APP_DEBUG_USER_EMAIL,
  DEBUG_LOJA: process.env.REACT_APP_DEBUG_LOJA,
  STORES_ENDPOINT: process.env.REACT_APP_STORES_ENDPOINT,
  ROLE_ADMIN: "ADMIN",
  ROLE_USER: "USER",
  ALL_ROLES: ["ADMIN", "USER"],
  CONTEXT: process.env.REACT_APP_CONTEXT,
  MAESTRO_MAIN_SOLUTION_VERSION:
    process.env.REACT_APP_MAESTRO_MAIN_SOLUTION_VERSION,
  DAYS_TO_CANCEL: process.env.REACT_APP_DAYS_TO_CANCEL,
  DAYS_TO_CANCEL_CEC: process.env.REACT_APP_DAYS_TO_CANCEL_CEC,
  DAYS_TO_DEVOLUTION: process.env.REACT_APP_DAYS_TO_DEVOLUTION,
  RECAPTCHA_KEY: process.env.REACT_APP_RECAPTCHA_KEY,
  DISABLE_RECAPTCHA: process.env.REACT_APP_DISABLE_RECAPTCHA,
  LAIS_URL: process.env.REACT_APP_LAIS_URL,
  CODS_SAP: process.env.REACT_APP_CODS_SAP,
  ENABLE_CLARITY: process.env.REACT_APP_ENABLE_CLARITY === "true",
  SECONDS_TO_ALERT_DEVOLUTION_ABBIAMO: process.env.REACT_APP_SECONDS_TO_ALERT_DEVOLUTION_ABBIAMO,
};

export default {
  ...defaultValues,
  ...values,
};
